import script from "./CurrentBookingsSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentBookingsSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./CurrentBookingsSkeleton.vue?vue&type=style&index=0&id=4e144d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e144d6c"]])

export default __exports__